export var SWITCH_CLASS_PREFIX = 'Switch';
export var switchIdPrefix = 'switch-id-';